import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import './StaffPage.css';

const MyCensorDataPage = () => {
  const [formData, setFormData] = useState({
    fornavn: '',
    efternavn: '',
    email: '',
    telefon: '',
    adresse: '',
    postnummer: '',
    forstad: ''
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchMyData();
  }, []);

  const fetchMyData = async () => {
    try {
      const res = await apiClient.get('/api/censorer/me');
      // Fyld formularen med eksisterende data
      setFormData({
        fornavn: res.data.fornavn || '',
        efternavn: res.data.efternavn || '',
        email: res.data.email || '',
        telefon: res.data.telefon || '',
        adresse: res.data.adresse || '',
        postnummer: res.data.postnummer || '',
        forstad: res.data.forstad || ''
      });
      setLoading(false);
    } catch (err) {
      console.error(err);
      setMessage({ type: 'error', text: 'Kunne ikke hente oplysninger.' });
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    try {
      await apiClient.put('/api/censorer/me', formData);
      setMessage({ type: 'success', text: 'Dine oplysninger er opdateret.' });
    } catch (err) {
      console.error(err);
      setMessage({ type: 'error', text: 'Der skete en fejl ved lagring.' });
    }
  };

  if (loading) return <div style={{padding:'20px'}}>Henter data...</div>;

  return (
    <div>
      <div className="table-card">
        <h2 style={{color: '#003366', marginBottom: '1.5rem'}}>Rediger Stamdata</h2>
        <p style={{marginBottom: '2rem', color: '#666'}}>
          Her kan du rette de oplysninger, som skolerne bruger til at kontakte dig.
          <br/>
          (Beskikkelse og status kan kun ændres af en administrator).
        </p>

        {message && (
          <div style={{
            padding: '12px', marginBottom: '20px', borderRadius: '6px',
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24'
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{maxWidth: '800px'}}>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px'}}>
            
            <div className="form-group">
              <label style={{display:'block', marginBottom:'5px', fontWeight:'600'}}>Fornavn</label>
              <input 
                name="fornavn" value={formData.fornavn} onChange={handleChange} required 
                style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ddd'}}
              />
            </div>

            <div className="form-group">
              <label style={{display:'block', marginBottom:'5px', fontWeight:'600'}}>Efternavn</label>
              <input 
                name="efternavn" value={formData.efternavn} onChange={handleChange} required 
                style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ddd'}}
              />
            </div>

            <div className="form-group">
              <label style={{display:'block', marginBottom:'5px', fontWeight:'600'}}>Email</label>
              <input 
                type="email" name="email" value={formData.email} onChange={handleChange} required 
                style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ddd'}}
              />
            </div>

            <div className="form-group">
              <label style={{display:'block', marginBottom:'5px', fontWeight:'600'}}>Telefon</label>
              <input 
                name="telefon" value={formData.telefon} onChange={handleChange} 
                style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ddd'}}
              />
            </div>

            <div className="form-group" style={{gridColumn: '1 / -1'}}>
              <label style={{display:'block', marginBottom:'5px', fontWeight:'600'}}>Adresse</label>
              <input 
                name="adresse" value={formData.adresse} onChange={handleChange} 
                style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ddd'}}
              />
            </div>

            <div className="form-group">
              <label style={{display:'block', marginBottom:'5px', fontWeight:'600'}}>Postnummer</label>
              <input 
                name="postnummer" value={formData.postnummer} onChange={handleChange} 
                style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ddd'}}
              />
            </div>

            <div className="form-group">
              <label style={{display:'block', marginBottom:'5px', fontWeight:'600'}}>By</label>
              <input 
                name="forstad" value={formData.forstad} onChange={handleChange} 
                style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ddd'}}
              />
            </div>

          </div>

          <div style={{marginTop: '2rem'}}>
            <button 
              type="submit" 
              style={{
                backgroundColor: '#003366', color: 'white', padding: '12px 24px', 
                border: 'none', borderRadius: '6px', fontSize: '1rem', cursor: 'pointer'
              }}
            >
              Gem Ændringer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MyCensorDataPage;